var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-address"},[_c('AddressBlockie',{attrs:{"address":_vm.address,"scale":2}}),_c('AddressArgument',{attrs:{"value":_vm.address,"ellipsize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }